module.exports = {
    // document title
    Title: "超强伟业",

    CDN: 'https://cdn.suplaserai.com',

    WxmpAccounts: [
        {
            value: "default",
            label: "无锡超强伟业科技有限公司",
        },
    ],

    tokenExpires: 2592000000 // 30 days
};
